import { render, staticRenderFns } from "./stairs.vue?vue&type=template&id=1f7b2ac3&scoped=true&"
import script from "./stairs.vue?vue&type=script&lang=js&"
export * from "./stairs.vue?vue&type=script&lang=js&"
import style0 from "./stairs.vue?vue&type=style&index=0&id=1f7b2ac3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7b2ac3",
  null
  
)

export default component.exports